@if (!isIE11Browser) {
  <svg [ngClass]="[className]">
    <use [attr.xlink:href]="'assets/images/sprite.svg#' + type"></use>
  </svg>
}
@if (isIE11Browser && type != 'sort-asc'  ) {
  <div [ngClass]="[className]" [innerHTML]="safeHTML">
  </div>
}

@if (isIE11Browser && type == 'sort-asc'  ) {
  <span [ngClass]="[className]" [innerHTML]="safeHTML">
  </span>
}
